export const inputEquipmentId = {
    bindings: {
        module: '@',
        identifier: '@'
    },
    template: require('./input-equipment-id.html'),
    controller: 'InputEquipmentIdController'
};
